import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { OwnerInfo } from '../slack-tab/slack-tab.interface';

@Component({
  selector: 'mode-slack-not-linked',
  templateUrl: './slack-not-linked.component.html',
  styleUrls: ['./slack-not-linked.component.scss'],
})
export class SlackNotLinkedComponent implements OnInit {
  @Input()
  owner: OwnerInfo | undefined;

  copyLink = '';
  hostUrl = '';
  slackAppSettingsUrl = '';
  isOwnerAdmin = false;

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  ngOnInit(): void {
    this.hostUrl = this._document.location.origin;
    this.isOwnerAdmin = this.owner?.membershipType === 'admin';
    this.slackAppSettingsUrl = `/organizations/${this.owner?.username}/slack_apps`;
    this.copyLink = `${this.hostUrl}${this.slackAppSettingsUrl}`;
  }
}
